import { useEffect, useState } from "react";
import { tss } from "tss-react/mui";
import { IconButton, Menu } from "@mui/material";
import commonStyles from "styles/common";
import { SketchPicker } from "react-color";

const useStyles = tss.create(({theme}) => ({
    root: {
        display: "inline-flex",
        alignItems: "center",
    },
    sliderInput: {
        display: "inline-block",
        width: 70,
        outline: 0,
        border: 0,
        borderBottom: `solid 1px ${theme.palette.divider}`,
        textAlign: "right",
        padding: "5px 5px",
        marginRight: 5,
        color: theme.palette.text.secondary
    },
    inputColor: {
        position: "relative",
    },
    iconButton: {
        width: 16,
        height: 16,
        minWidth: 16,
        borderRadius: 1,
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.15)",
        cursor: "pointer",
    },
    colorBox: {
        cursor: "pointer",
        width: 15,
        height: 15,
        display: "inline-block",
        backgroundColor: "#ccc",
        position: "relative",
        left: 0,
        top: 3,
        border: "solid 1px #E6E6E6",
    },
    palette: {
        height: 180,
        zIndex: 1000,
        marginTop: -8,
        overflow: "hidden",
        marginBottom: -8,
    },
    longPalette: {
        height: 230,
        zIndex: 1000,
        marginTop: -8,
        overflow: "hidden",
        marginBottom: -8,
    },
}));

var colorSettings: any = [];

type IColorPicker = {
    name: string;
    defaultColor: string;
    rgbMode?: boolean;
    id?: string;
    handleColorChange: (name: string, color: string) => void;
};

export default function ColorPicker(props: IColorPicker) {
    const { classes } = useStyles();
    const { classes: common } = commonStyles();
    var { id, name, defaultColor, rgbMode, handleColorChange } = props;
    if (!id) {
        id = "picker";
    }
    if (typeof colorSettings[name + "-" + id] === "undefined") {
        colorSettings[name + "-" + id] = defaultColor;
    }
    useEffect(() => {
        colorSettings[name] = props.defaultColor;
        setUpdate((prevUpate) => !prevUpate);
    }, [id, name, props.defaultColor]);

    let [anchorEl, setAnchorEl] = useState(null);
    let [update, setUpdate] = useState(false);
    let palette: any;
    var colorValue = colorSettings[name + "-" + id];

    const togglePalette = () => {
        var input = document.getElementById("input" + name);
        var visible = false;
        if (input && input.style.display === "none") {
            visible = false;
        } else {
            visible = true;
        }
        if (palette && input) {
            palette.style.display = visible ? "inline-flex" : "none";
            input.style.display = visible ? "none" : "inline-block";
        }
    };

    const handlePaletteColorChange = (newValue: any) => {
        if (rgbMode) {
            handleChange(name, newValue.rgb);
        } else {
            handleChange(name, newValue.hex.toUpperCase());
        }
    };

    const handleChange = (name: string, value: string) => {
        togglePalette();
        if (rgbMode) {
            handleColorChange(name, value);
        } else {
            colorSettings[name + "-" + id] = value.toUpperCase();
            handleColorChange(name, value);
            setUpdate(!update);
        }
    };

    const showMenu = (evt: any) => {
        setAnchorEl(evt.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className={classes.root}>
            <div id={"input" + name} className={classes.inputColor}>
                <input
                    value={colorValue}
                    className={classes.sliderInput}
                    onChange={(e) => {
                        handleChange(name, e.target.value);
                    }}
                />

                <IconButton
                    className={[common.button, classes.iconButton].join(" ")}
                    aria-controls="menu-list-grow"
                    aria-haspopup="true"
                    style={{
                        backgroundColor: colorValue,
                    }}
                    onClick={showMenu}
                ></IconButton>
                <Menu
                    id="menu-list-grow"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                    }}
                    style={{ marginLeft: 5 }}
                >
                    <SketchPicker
                        className={rgbMode ? classes.longPalette : classes.palette}
                        color={colorValue}
                        onChangeComplete={handlePaletteColorChange}
                    />
                </Menu>
            </div>
        </div>
    );
}
